import { render, staticRenderFns } from "./surrenderList.vue?vue&type=template&id=07636eaa&scoped=true&"
import script from "./surrenderList.vue?vue&type=script&lang=js&"
export * from "./surrenderList.vue?vue&type=script&lang=js&"
import style0 from "./surrenderList.vue?vue&type=style&index=0&id=07636eaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07636eaa",
  null
  
)

export default component.exports